<template>
  <aside
    data-grid="column"
    class="contentgrid__aside grid--nowrap p-fixed h-100 p-0"
    :class="dynamicAsideClasses"
  >
    <span
      data-grid
      class="contentgrid__sidetoggle grid--va-center grid--center p-absolute cursor-pointer my-1"
      @click.stop="setIsAsideOpened(null)"
    >
      <ArrowDownIcon />
    </span>

    <slot name="header">
      <AsyncSideHeader
        :logo="require('../../assets/images/logos/increazy-dash-white.svg')"
      />
    </slot>

    <slot :is-opened="getIsAsideOpened" />
  </aside>
</template>

<script>
import { defineComponent, defineAsyncComponent } from 'vue'
import { mapActions, mapGetters } from 'vuex'

import ArrowDownIcon from '../../icons/ArrowDownIcon'

const AsyncSideHeader = defineAsyncComponent(() => import('./components/SideHeader'))

export default defineComponent({
  name: 'SideMenu',

  components: {
    ArrowDownIcon,
    AsyncSideHeader
  },

  computed: {
    ...mapGetters({
      getIsAsideOpened: 'global/getIsAsideOpened'
    }),

    dynamicAsideClasses () {
      return {
        'closed-aside': !this.getIsAsideOpened
      }
    }
  },

  watch: {
    getIsAsideOpened (value) {
      if (value) return

      const openedChilds = [...document.querySelectorAll('.contentgrid__aside .opened')]

      for (let i = 0, len = openedChilds.length; i < len; i++) {
        openedChilds[i].classList.remove('opened')
      }
    },

    $route: {
      deep: true,
      handler (r) {
        let previousPath = ''

        if ((this.$router.options.history.state.back || '').includes('?')) {
          previousPath = (this.$router.options.history.state.back || '').split('?')[0]
        } else {
          previousPath = this.$router.options.history.state.back
        }

        if (previousPath !== r.path && previousPath === null) {
          this.setIsAsideOpened(false)
        }
      }
    }
  },

  methods: {
    ...mapActions({
      setIsAsideOpened: 'global/setIsAsideOpened'
    })
  }
})
</script>

<style lang="scss" scoped>
  .contentgrid {
    &__aside {
      z-index: 12;
      transition: all .2s ease-in-out;
      box-shadow: 5px 0 30px -10px rgb(0 0 0 / 20%);

      width: var(--sidemenu-width);
      background-color: var(--white-background-theme);

      // still apears, but with a small width
      &.closed-aside {
        --sidemenu-width: 60px;

        .contentgrid__sidetoggle {
          --rotate: -90deg;
        }

        & + :deep(main) {
          margin-inline: 60px 0;
        }
      }

      // when is completely hidden
      &.hidden-aside {
        margin-inline: calc(var(--sidemenu-width) * -1) 0;

        .contentgrid__sidetoggle {
          margin-inline: 14px 0;
        }

        & + :deep(main) {
          margin-inline: 0;
        }
      }

      & + :deep(main) {
        margin-inline: var(--sidemenu-width) 0;
      }
    }

    &__sidetoggle {
      --rotate: 90deg;
      --shadowColor: rgb(var(--white));

      top: 135px;
      left: 100%;
      z-index: 10;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      transition: all .2s ease-in-out;
      box-shadow: 0 0 0 4px var(--shadowColor);
      transform: translateX(-50%) rotate(var(--rotate));

      color: rgb(var(--white));
      background-color: var(--primary);

      .is-dark-theme & {
        --shadowColor: transparent;
      }

      svg {
        flex: 0 0 55%;
        max-width: 55%;
        max-height: 55%;
        transform: scale(.7);
      }
    }

    @media (min-width: 1024px) {
      &__aside.closed-aside {
        --sidemenu-width: 80px;

        & + :deep(main) {
          margin-inline: 80px 0;
        }
      }
    }
  }
</style>
